/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Continue_MicrosoftInputs */

const en_login_continue_microsoft = /** @type {(inputs: Login_Continue_MicrosoftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continue with Microsoft`)
};

const ar_login_continue_microsoft = /** @type {(inputs: Login_Continue_MicrosoftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`المتابعة مع Microsoft`)
};

/**
* | output |
* | --- |
* | "Continue with Microsoft" |
*
* @param {Login_Continue_MicrosoftInputs} inputs
* @param {{ locale?: "en" | "ar" }} options
* @returns {LocalizedString}
*/
export const login_continue_microsoft = /** @type {((inputs?: Login_Continue_MicrosoftInputs, options?: { locale?: "en" | "ar" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Continue_MicrosoftInputs, { locale?: "en" | "ar" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_login_continue_microsoft(inputs)
	return ar_login_continue_microsoft(inputs)
});